export default __webpack_public_path__ + "22826a8b1f8d832f11c147154e96ee5b.svg";